import React, { lazy, Suspense, useMemo, useState } from 'react';
import './App.css';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { UserContext } from './context/UserContext';
import VideoRoom from './components/VideoRoom';
import Error from './components/Error';
import WaitingRoom from './components/WaitingRoom';
import EndCall from './components/EndCall';
import HlsComponent from 'components/HlsComponent';
import AuthComponent from 'components/AuthComponent';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { Toaster } from 'react-hot-toast';
import SubscriberPage from 'components/Subscribers';
import { RoleProvider } from '../src/context/RoleContext';

// Lazy Load PreCallTest
const PreCallTest = lazy(() => import('components/PreCallTest'));

let primary = process.env.REACT_APP_PALETTE_PRIMARY || '#3e7bf4';
let secondary = process.env.REACT_APP_PALETTE_SECONDARY || '#d6219c';

const theme = () => {
  return createTheme({
    palette: {
      type: 'light',
      primary: {
        main: primary,
      },
      secondary: {
        main: secondary,
      },
      bodyBackground: {
        black: '#131415',
      },
      callBackground: {
        main: '#20262D',
      },
      toolbarBackground: {
        main: '#41464D',
      },
      activeButtons: {
        green: '#1C8731',
        red: '#D50F2C',
      },
    },
  });
};

function App() {
  const [user, setUser] = useState({
    videoFilter: {
      filterName: localStorage.getItem('filterName'),
      filterPayload: localStorage.getItem('filterPayload'),
    },
    defaultSettings: {
      publishAudio: false,
      publishVideo: false,
      audioSource: undefined,
      videoSource: undefined,
      audioOutput: undefined,
    },
  });

  const userValue = useMemo(() => ({ user, setUser }), [user, setUser]);

  return (
    <ThemeProvider theme={theme()}>
      <Router>
        <Toaster />
        <UserContext.Provider value={userValue}>
          <RoleProvider>
            <Switch>
              <Route exact path='/:pid/:userName/:userId/:sessionId/end'>
                <EndCall />
              </Route>
              <Route
                exact
                path='/WebMeeting/:pid/:userName/:userId/:roleName'
                component={VideoRoom}
              />
              <Route
                exact
                path='/SubscriberPage/:pid/:userid/:username/viewer'
                component={SubscriberPage}
              />
              <Route path='/error' component={Error}></Route>
              <Route
                exact
                path='/WaitingRoom/:pid/:userName/:userId/:roleName/:meetingFlag'
                component={WaitingRoom}
              ></Route>
              <Route
                exact
                path='/'
                element={AuthComponent(WaitingRoom)}
              ></Route>
              <Route
                exact
                path='/broadcast/:pid/:userid/:roleName'
                component={HlsComponent}
              ></Route>

              {/* Lazy Loaded PreCallTest */}
              <Route exact path='/test/precall'>
                <Suspense fallback={<div>Loading PreCall Test...</div>}>
                  <PreCallTest />
                </Suspense>
              </Route>
            </Switch>
          </RoleProvider>
        </UserContext.Provider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
